import styled from '@emotion/styled'
import { startCase } from 'lodash'
import React from 'react'
import Card from '../../../../components/Card.ui'
import { Select } from '../../../../components/Form.ui'
import { useTeam } from '../../data/team'
const MemberListContainer = styled('div')`
    display: flex;
    flex-direction: column;
`
export const MemberListItem = styled(Card)`
    height: fit-content;
    min-height: fit-content;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    overflow: initial;
    margin-bottom: 0.75rem;
    place-items: center;
    span {
        align-self: center;
    }
    img {
        height: 2rem;
        width: 2rem;
        flex-shrink: 0;
        border-radius: 50%;
        object-fit: cover;
        box-shadow: var(--boxShadow-accent1);
        padding: 0;
        margin: 0.25rem;
        border: var(--borders-main);
    }
`

const MemberList = (props) => {
    const [{ activeTeam, api }] = useTeam()

    return (
        <MemberListContainer>
            {props?.members
                ?.filter((e) => !!e.nickName)
                .map((e, i) => (
                    <MemberListItem
                        key={e._id}
                        onClick={() => props.onMemberClick?.(e)}
                    >
                        <strong>{e.shirtNumber}</strong>
                        <span style={{ width: '100%' }}>{e.nickName}</span>
                        {e.image && <img src={e.image}></img>}
                        {props.canEdit && props.eventId && (
                            <Select
                                options={[
                                    'going',
                                    'maybe',
                                    'notGoing',
                                    'notResponded',
                                ]}
                                isSearchable={false}
                                value={props.attendance}
                                onChange={(value) =>
                                    console.log({ value, e }) ||
                                    api
                                        .updateMemberAttendance(
                                            props.eventId,
                                            { status: value },
                                            e._id
                                        )
                                        .then(() => props?.onChange?.())
                                }
                                placeholder="attendance"
                            ></Select>
                        )}
                    </MemberListItem>
                ))}
        </MemberListContainer>
    )
}

export default MemberList
